export default {
    BASE_URL: 'https://pevidemsc-dot-ioapi2.appspot.com'
    //BASE_URL: 'http://localhost:8084'
}
